export function getBookingBasicInfoEndpoint() {
  return '/traveltek/get_booking_basic_info.php';
}

export function getBookingDeckInfoEndpoint() {
  return '/traveltek/get_booking_deck_info.php';
}

export function getBookingBasketEndpoint() {
  return '/traveltek/add_cruise_basket.php';
}

export function getCruisePaxDataEndpoint() {
  return '/traveltek/get_cruise_pax_data.php';
}

export function resolveTraveltekResultNo(resultno, gradeno = '') {
  return String(resultno || '').trim();
}

export function resolveBookingResultNo(gradeInfo) {
  if (!gradeInfo || typeof gradeInfo !== 'object') return '';

  const selectedPricing = gradeInfo?.gridPrice;
  const gridMeta = gradeInfo?.gridMeta;
  const directCandidates = [
    gradeInfo?.resultno,
    selectedPricing?.resultno,
    selectedPricing?.rate?.resultno,
    gridMeta?.resultno,
  ];

  for (const candidate of directCandidates) {
    const normalized = String(candidate || '').trim();
    if (normalized) return normalized;
  }

  return '';
}

function appendIfPresent(params, key, value) {
  if (value === null || value === undefined) return;
  const stringValue = String(value).trim();
  if (stringValue === '') return;
  params.set(key, stringValue);
}

export function buildBookingBasicInfoUrl({
  cruiseId,
  adults,
  children,
  childDob = '',
  includeSenior = false,
  adultDob = '',
  pastpax = '',
  ratecodes = '',
  allratecodes = '',
}) {
  const params = new URLSearchParams({
    codetocruiseid: String(cruiseId),
    adults: String(adults),
    children: String(children),
  });

  appendIfPresent(params, 'childrenDob', childDob);
  if (includeSenior) {
    params.set('includesenior', 'true');
    appendIfPresent(params, 'adultDobs', adultDob);
  }
  appendIfPresent(params, 'pastpax', pastpax);
  appendIfPresent(params, 'ratecodes', ratecodes);
  appendIfPresent(params, 'allratecodes', allratecodes);

  return `${getBookingBasicInfoEndpoint()}?${params.toString()}`;
}

export function buildCruisePaxDataUrl({
  lineId,
  firstName,
  lastName,
  dob,
  cruiseId = '',
  shipId = '',
}) {
  const params = new URLSearchParams({
    lineid: String(lineId || ''),
    firstname: String(firstName || '').trim(),
    lastname: String(lastName || '').trim(),
    dob: String(dob || '').trim(),
  });
  appendIfPresent(params, 'codetocruiseid', cruiseId);
  appendIfPresent(params, 'ship_id', shipId);

  return `${getCruisePaxDataEndpoint()}?${params.toString()}`;
}

export function canBuildBookingDeckInfoRequest({ gradeno, ratecode, resultno }) {
  if (!gradeno || !ratecode) return false;
  return true;
}

export function buildBookingDeckInfoUrl({
  sessionKey,
  cruiseId,
  gradeno,
  resultno,
  adults,
  childrenTotal,
  ratecode,
}) {
  const params = new URLSearchParams({
    sessionkey: String(sessionKey || ''),
    codetocruiseid: String(cruiseId),
    gradeno: String(gradeno),
    adults: String(adults),
    children: String(childrenTotal),
    horizontaldeckplans: '1',
    showalldecks: '1',
    ratecode: String(ratecode),
  });

  appendIfPresent(params, 'resultno', resultno);
  params.set('language', 'kr');

  return `${getBookingDeckInfoEndpoint()}?${params.toString()}`;
}

export function buildBookingBasketUrl({
  sessionKey,
  cruiseId,
  shipId,
  resultNO,
  gradeNo,
  cabinResult,
  rateCode,
}) {
  const params = new URLSearchParams({
    sessionkey: String(sessionKey || ''),
    resultkey: 'Default',
    type: 'cruise',
    gradeno: String(gradeNo),
    cabinresult: String(cabinResult),
    ratecode: String(rateCode),
  });
  appendIfPresent(params, 'resultno', resultNO);
  appendIfPresent(params, 'codetocruiseid', cruiseId);
  appendIfPresent(params, 'ship_id', shipId);

  return `${getBookingBasketEndpoint()}?${params.toString()}`;
}

export function getBookingGroupsCacheKey(scheduleId) {
  if (scheduleId == null) return null;
  return `booking:groups:${scheduleId}`;
}

export function getBookingBasketCacheNamespace() {
  return 'booking:basket:';
}

export function getBookingBasketCachePrefix(scheduleId) {
  const namespace = getBookingBasketCacheNamespace();
  return scheduleId != null ? `${namespace}${scheduleId}:` : `${namespace}global:`;
}

export function isBookingBasketCacheKeyForSchedule(key, scheduleId) {
  if (!key || !key.startsWith('booking:basket:')) return false;
  if (scheduleId == null) return true;

  const normalizedScheduleId = String(scheduleId);
  const suffix = key.slice('booking:basket:'.length);

  if (suffix.startsWith(`${normalizedScheduleId}:`)) {
    return true;
  }

  const firstSeparatorIndex = suffix.indexOf(':');
  if (firstSeparatorIndex === -1) {
    return false;
  }

  return suffix.slice(firstSeparatorIndex + 1).startsWith(`${normalizedScheduleId}:`);
}

export function buildBookingBasketCacheKey({
  scheduleId,
  cruiseId,
  resultNO,
  gradeNo,
  rateCode,
  cabinResult,
}) {
  const prefix = getBookingBasketCachePrefix(scheduleId);
  const primaryKey = resultNO !== null && resultNO !== undefined && String(resultNO).trim() !== ''
    ? `result:${String(resultNO)}`
    : `cruise:${String(cruiseId || '')}`;
  return `${prefix}${primaryKey}:${String(gradeNo)}:${String(rateCode)}:${String(cabinResult)}`;
}
